<ion-app [class.dark-theme]="dark" lang="{{ appLanguage }}" dir="{{languageDirection}}">
    <ion-router-outlet id="main-content" attr.bMove={{isBrowserMove}}></ion-router-outlet>
</ion-app>
